import { render, staticRenderFns } from "./StockItemShow.vue?vue&type=template&id=045b9e1a&scoped=true"
import script from "./StockItemShow.vue?vue&type=script&lang=js"
export * from "./StockItemShow.vue?vue&type=script&lang=js"
import style0 from "./StockItemShow.vue?vue&type=style&index=0&id=045b9e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b9e1a",
  null
  
)

export default component.exports